import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  content_id: null,
  content_tag: null,
  content_name: null,
  content_type: null,
  content_URL: null,
  content_fileName: null,
  content_format: null,
  content_3DfileName: null,
  content_3Dos: null,
  content_3Did: null,

  content_3DTag: null,

  content_duration: null,
  content_description: null,
  content_status: null,
  content_file: null,
  content_buName: null,
  content_divName: null,
  content_applicationID: null,
  content_edit: false,
  division_edit: false,
  product_edit: false,

  content_btn: false,

  contentIsPane: false,
  contentIsPane1: false,
  addContentIsPane: false,
  addContentIsPane1: false,
  content_filterVR: true,

  bu_viewcontent: null,
  division_viewcontent: null,
  product_viewcontent: null,
  productId_viewcontent : null,
  col1_visible : false,

};
export const VRcontentReducerInner = createSlice({
  name: "VRcontent",
  initialState: initialState,
  reducers: {
    content_id(state, action) {
      state.content_id = action.payload;
    },
    content_3Did(state, action) {
      state.content_3Did = action.payload;
    },

    content_name(state, action) {
      state.content_name = action.payload;
    },
    content_tag(state, action) {
      state.content_tag = action.payload;
    },

    content_type(state, action) {
      state.content_type = action.payload;
    },
    content_format(state, action) {
      state.content_format = action.payload;
    },
    content_fileName(state, action) {
      state.content_fileName = action.payload;
    },
    content_description(state, action) {
      state.content_description = action.payload;
    },
    content_buName(state, action) {
      state.content_buName = action.payload;
    },
    content_divName(state, action) {
      state.content_divName = action.payload;
    },
    content_applicationID(state, action) {
      state.content_applicationID = action.payload;
    },
    content_3DfileName(state, action) {
      state.content_3DfileName = action.payload;
    },
    content_3Dos(state, action) {
      state.content_3Dos = action.payload;
    },
    content_3DTag(state, action) {
      state.content_3DTag = action.payload;
    },
    content_edit(state, action) {
      state.content_edit = action.payload;
    },
    division_edit(state, action) {
      state.division_edit = action.payload;
    },
    product_edit(state, action) {
      state.product_edit = action.payload;
    },
    content_btn(state, action) {
      state.content_btn = action.payload;
    },
    content_IsPane(state, action) {
      state.contentIsPane = action.payload;
    },
    addContent_IsPane(state, action) {
      state.addContentIsPane = action.payload;
    },
    content_status(state, action) {
      state.content_status = action.payload;
    },
    addContent_IsPane1(state, action) {
      state.addContentIsPane1 = action.payload;
    },
    content_filterVR(state, action) {
      state.content_filterVR = action.payload;
    },


    division_viewcontent(state, action) {
      state.division_viewcontent = action.payload;
    },
    bu_viewcontent(state, action) {
      state.bu_viewcontent = action.payload;
    },
    product_viewcontent(state, action) {
      state.product_viewcontent = action.payload;
    },
    productId_viewcontent(state, action) {
      state.productId_viewcontent = action.payload;
    },
    col1_visible(state, action) {
      state.col1_visible = action.payload;
    },
  },
});
